module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_isTransformer.js
// module id = ../../node_modules/ramda/src/internal/_isTransformer.js
// module chunks = 18